import { z } from 'zod';
import { idSchema } from './common.js';
export const userRoleSchema = z.enum(['grower', 'staff', 'admin']);
/** The signed-in user as returned by the API. Never includes secrets. */
export const userSchema = z.object({
    id: idSchema,
    username: z.string().min(1),
    displayName: z.string().min(1),
    role: userRoleSchema,
    /** Farms this user may capture for. Staff and admin may see all farms; the list is still explicit. */
    farmIds: z.array(idSchema),
});
export const loginRequestSchema = z.object({
    username: z.string().trim().min(1),
    password: z.string().min(1),
    /** When true the refresh cookie persists beyond the browser session. */
    remember: z.boolean().default(false),
});
/** The refresh token travels in an httpOnly cookie, so only the access token is in the body. */
export const loginResponseSchema = z.object({
    accessToken: z.string().min(1),
    user: userSchema,
});
export const refreshResponseSchema = z.object({
    accessToken: z.string().min(1),
});
export const forgotPasswordRequestSchema = z.object({
    username: z.string().trim().min(1),
});
export const resetPasswordRequestSchema = z.object({
    token: z.string().min(1),
    password: z.string().min(8, 'Use at least 8 characters.'),
});
//# sourceMappingURL=auth.js.map